export const VEHICLE = [
  {code: 'JUST_GO', item: 'JustGo'},
  {code: 'SEATS4', item: 'FastCar 4 chỗ'},
  {code: 'SEATS7', item: 'FastCar 7 chỗ'},
  {code: 'SEATS2', item: 'FastBike'}
];

